module.exports = "/_next/static/images/Integration@2x-ebdcbe47bf391b90b3f8d8a364e64c7f.webp";